import {Fragment, useEffect, useState} from 'react';

import {IntegrationDevice as Service} from './IntegrationDeviceService';
import {StoreService} from '../cua-hang-xang-dau/StoreService';
import {TaxService} from '../thue-suat/TaxService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {ConfirmDialogService} from '../../../AppConfirmDialog'; 
import {RegisterInvoiceService} from '../../../service/invoice/RegisterInvoiceService';
import {PetrolimexService} from '../hang-hoa-xang-dau/PetrolimexService';
export const List = () => {

  const header = 'Danh mục thiết bị tích hợp';
  const dataKey = 'id';
  const deviceTypes = [
    {value: "loa", label: 'Loa thanh toán'} 
  ];
  const [petrolimexs, setPetrolimexs] = useState([]);
  const [stores, setStores] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [serials, setRegisterInvoice] = useState(null);
  const [manyActions, setManyActions] = useState([]);

  useEffect(() => {
    RegisterInvoiceService.getUsingList({maxResultCount: 1000}).then(({items}) => {
      const _serials = [];
      items.forEach((item) => {
        _serials.push({value: item.id, label: item.symbolCode});
      });
      setRegisterInvoice(_serials);
    });

    PetrolimexService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({items}) => {
      const _petrolimexs = [];
      items.forEach(item => {
        _petrolimexs.push({value: item.code, label: item.code +' - ' + item.name});
      });
      setPetrolimexs(_petrolimexs);
    });
    StoreService.getList({
      skipCount: 0,
      maxResultCount: 1000,
    }).then(({items}) => {
      const _stores = [];
      items.forEach(item => {
        _stores.push({value: item.code, label:  item.code +' - ' + item.storeName});
      });
      setStores(_stores);
    });
    TaxService.getList({}).then(({items}) => {
      const _taxs = [];
      items.forEach((item) => {
        _taxs.push({value: item.id, label: item.name, ratio: item.ratio});
      });
      setTaxs(_taxs);
    });
  }, []);

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems, dataTableParams} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: 'Mã thiết bị', width: 200, matchMode: 'contains'},
      {field: 'name', header: 'Tên thiết bị', minWidth: 220, matchMode: 'contains'},
      {field: 'invoiceSerial', header: 'Ký hiệu', minWidth: 200, matchMode: 'contains'},
      {field: 'type', header: 'Loại tích hợp', width: 250, filterOptions: deviceTypes, dataType: 'fromFilterOptions'},
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });
  useEffect(() => {
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const {render: renderDialogCrup, create, update, clone, getValue, setValue, touched} = useDialogCrup({
    header,
    dataKey,
    width: '60rem',
    fields: [
     
      {field: 'code', header: 'Mã thiết bị', required: true,InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'name', header: 'Tên thiết bị', required: true,InputTextProps: {maxLength: 50}, className: 'md:col-6'},,
      {field: 'registerInvoiceId', header: 'Ký hiệu',required: true, type: 'Dropdown', DropdownProps: {options: serials, filter: true}, className: 'md:col-6'},
      {field: 'type', header: 'Loại tích hợp', required: true,type: 'Dropdown', DropdownProps: {options: deviceTypes}, className: 'md:col-6'},
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {taxId, listPrice} = getValue();

  useEffect(() => {
    if (touched) {
      const _value = getValue();
      _value.price = 0;
      if (listPrice > 0) {
        _value.price = listPrice;
      }
      if (taxId) {
        const ratio = taxs.find(it => it.value === taxId)?.ratio;
        if (listPrice > 0 && ratio > 0) {
          _value.price = formatNumber(listPrice / (1 + ratio / 100));
        }
      }
      setValue(_value);
    }
  }, [taxId, listPrice]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatNumber = number => {
    if (typeof number === 'number') {
      if (!Number.isFinite(number) || Number.isNaN(number)) {
        number = 0;
      }
      if (`${number}`.length > 2 && `${number}`.split('.').length) {
        number = 1 * number.toPrecision(`${number}`.split('.')[0].length + 2);
      }
    }
    return number;
  }

  const {renderToolbar, refreshToolbar} = useToolbar({
    dataKey, create,
    update: (item) => {
      Service.get(item[dataKey]).then(data => {
        if (data.price > 0) {
          data.listPrice = data.price;
        }
        if (data.ratioTax > 0 && data.price > 0) {
          data.listPrice = Math.round(data.price * (1 + data.ratioTax / 100));
        }
        update(data);
      });
    },
    clone: (item) => {
      Service.get(item[dataKey]).then(data => {
        clone(data);
      });
    },
    reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      ...manyActions,
    ]
  });

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({id}) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid('Bạn cần chọn thiết bị trước khi sửa');
      return;
    }
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
